import React, { useEffect, useState } from "react";
import Layout from "./../layouts/Index";
import Moment from "react-moment";
import { connect } from "react-redux";
import {
  getMoreRecommendations,
  getRecommendations,
  updateRecommendation,
} from "../../store/actions/RecommendationActions";
import BlockLoader from "./../contentloaders/BlockLoader";
import { Row, Col, Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import Switch from "react-switch";
import { instance, setAuthToken } from "../../helpers/instance";

function Index(props) {
  // Props
  const {
    getRecommendations,
    recommendations: { page, pages, data },
    getMoreRecommendations,
    updateRecommendation,
  } = props;

  // States
  const [loading, setLoading] = useState(false);

  // Effects
  useEffect(() => {
    async function fetchRecommendations() {
      try {
        setLoading(true);
        await getRecommendations();
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    }
    fetchRecommendations();
  }, []);

  // Functions
  const fetchMoreRecommendations = async () => {
    try {
      setLoading(true);
      const {
        recommendations: { next_page },
      } = props;
      const result = await getMoreRecommendations(next_page);
      if (result) {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleChange = async (id, checked) => {
    if (checked) {
          if (!window.confirm("This action is final and cannot be reversed. A message will be sent out to the customer. Are you sure you want to proceed?")) {
            return;
          }
        }
    try {
      let status = checked === true ? 1 : 0;
      const result = await updateRecommendation(id, { status });
      if (result) {
        // Refresh the only affected recommendation
        const updatedRecommendation = props.recommendations.data.find(rec => rec.id === id)
        if (updatedRecommendation) {
          updatedRecommendation.status = checked ? 1 : 0;
        }
        toast.success("Recommendation updated successfully", {
          position: "bottom-center",
        });
      }
    } catch (error) {
      toast.error(`An error occurred while updating the recommendation`, {
        position: "bottom-center",
      });
    }
  };

  return (
    <Layout>
      <Col sm="12" style={{ minHeight: "80vh", padding: "1.5em 0" }}>
        <Container>
          <Row>
            <Col
              sm="12"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: "row",
                marginBottom: "1em",
              }}
            >
              {!loading && <h3>Recommendations</h3>}

              {loading && (
                <div style={{ width: "100px", height: "35px" }}>
                  <BlockLoader
                    width="150px"
                    height="35"
                    innerHeight="100%"
                    innerWidth="100%"
                    style={{ margin: "0", padding: "0" }}
                  />
                </div>
              )}
            </Col>
            <Col sm="12">
              {!loading && (
                <div style={{ overflowX: "auto" }}>
                <Table
                  striped
                  bordered
                  hover
                  size="lg"
                  variant="light"
                  responsive="sm"
                  className="recommendations-table"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Product</th>
                      <th>Description</th>
                      <th>Quantity</th>
                      <th>Images</th>
                      <th>Created By</th>
                      <th>Date Created</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data.map((r, i) => (
                      <tr key={i}>
                        <td data-label="#"> {i + 1}</td>
                        <td data-label="Product">
                          <a
                            href={r.product_link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {r.product_name}
                          </a>
                        </td>
                        <td data-label="Description">{r.description !== "" ? r.description : "N/A"}</td>
                        <td data-label="Quantity">{r.quantity !== "" ? r.quantity : "N/A"}</td>
                        <td data-label="Images">
                          {Array.isArray(r.images) && r.images.length > 0 ? (
                            <div
                              style={{
                                postition: "relative",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                margin: "15px 0",
                              }}
                            >
                              {r.images.map((image, i) => (
                                <a key={i} href={image} target="_blank" rel="noreferrer">
                                  <img
                                    src={image}
                                    alt={image}
                                    style={{
                                      height: "100px",
                                      width: "100px",
                                    }}
                                  />
                                </a>
                              ))}
                            </div>
                          ) : (
                            <span>No Images</span>
                          )}
                        </td>
                        <td data-label="Created By">
                          {r?.user?.first_name} {r?.user?.last_name},{" "}
                          {r?.user?.msisdn}
                        </td>
                        <td data-label="Date Created">
                          <Moment format="DD/MM/YYYY H:mm">{r.date_created}</Moment>
                        </td>
                        <td data-label="Status">
                          <Switch
                            onChange={(checked) => handleChange(r?.id, checked)}
                            checked={r?.status === 1 ? true : false}
                            disabled={r.status === 1 ? true : false}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                </div>
              )}
            </Col>

            <Col sm="12">
              {loading && (
                <BlockLoader
                  width="100%"
                  height="400px"
                  innerWidth="100%"
                  innerHeight="100%"
                />
              )}
            </Col>
            {page < pages && (
              <Col
                sm="12"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "2em",
                }}
              >
                <Button
                  variant="primary"
                  size="lg"
                  onClick={() => fetchMoreRecommendations()}
                  disabled={loading}
                >
                  {loading === true ? "Loading ..." : "Load More"}
                </Button>
              </Col>
            )}
          </Row>
        </Container>
      </Col>
      <style>{`
        @media (max-width: 767px) {
        .recommendations-table thead {
          display: none;
        }
        .recommendations-table, .recommendations-table tbody, .recommendations-table tr, .recommendations-table td {
          display: block;
          width: 100%;
        }
        .recommendations-table tr {
          margin-bottom: 1rem;
          border-bottom: 2px solid #dee2e6;
        }
        .recommendations-table td {
          text-align: right;
          padding-left: 50%;
          position: relative;
          border: none;
          border-bottom: 1px solid #dee2e6;
        }
        .recommendations-table td:before {
          content: attr(data-label);
          position: absolute;
          left: 0;
          width: 50%;
          padding-left: 1rem;
          font-weight: bold;
          text-align: left;
          white-space: nowrap;
        }
        }
      `}</style>
    </Layout>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    recommendations: state.recommendations,
  };
};

export default connect(mapStateToProps, {
  getMoreRecommendations,
  getRecommendations,
  updateRecommendation,
})(Index);
